import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  SupplementaryInvoiceAvailableStock,
  SupplementaryInvoiceDetail,
  SupplementaryInvoiceLinkedStock,
  SupplementaryInvoiceStockItemHeaderSelection,
} from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SupplementaryInvoiceDetailService extends TmsWebBaseEditCreateService<
  SupplementaryInvoiceDetail,
  SupplementaryInvoiceDetail
> {
  constructor() {
    super('SupplementaryInvoiceDetail', $localize`Supplementary Invoice Detail`);
  }

  // Detail lines for a header (child grid on the Detail Lines tab).
  getForHeader(headerId: string): Observable<SupplementaryInvoiceDetail[]> {
    return this.httpService.get<SupplementaryInvoiceDetail[]>(
      `${this.apiUrl}/SupplementaryInvoiceHeader?id=${headerId}`,
    );
  }

  // Stock item headers a detail line can be spread over (with existing selection/pro-rata).
  stockItemHeaderSelection(detailId: string): Observable<SupplementaryInvoiceStockItemHeaderSelection[]> {
    return this.httpService.get<SupplementaryInvoiceStockItemHeaderSelection[]>(
      `${this.apiUrl}/StockItemHeaderSelection/${detailId}`,
    );
  }

  // Save the ticked stock item headers for a detail line (server diffs + re-apportions).
  updateStockItemHeaderLinks(detailId: string, stockItemHeaderIds: string[]): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/UpdateStockItemHeaderLinks`, { detailId, stockItemHeaderIds });
  }

  // Every stock item header linked to any detail line of the header (selection tab grid).
  linkedStockForHeader(headerId: string): Observable<SupplementaryInvoiceLinkedStock[]> {
    return this.httpService.get<SupplementaryInvoiceLinkedStock[]>(
      `${this.apiUrl}/LinkedStockForHeader?headerId=${headerId}`,
    );
  }

  // Available stock (supplementary invoices not all received) matching the Add Items modal search.
  searchAvailableStock(search: string): Observable<SupplementaryInvoiceAvailableStock[]> {
    return this.httpService.get<SupplementaryInvoiceAvailableStock[]>(
      `${this.apiUrl}/SearchAvailableStock?search=${encodeURIComponent(search ?? '')}`,
    );
  }

  // Add the ticked stock item headers to a detail line (additive; server re-apportions).
  addStockItemHeaderLinks(detailId: string, stockItemHeaderIds: string[]): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/AddStockItemHeaderLinks`, { detailId, stockItemHeaderIds });
  }

  // Unlink one stock item header from one detail line (server re-apportions + re-derives cost).
  removeStockItemHeaderLink(linkId: string): Observable<void> {
    return this.httpService.delete<void>(`${this.apiUrl}/RemoveStockItemHeaderLink/${linkId}`);
  }
}
